import { GameObject } from '../base/GameObject';
import { Earth } from './Earth';
import Phaser from 'phaser';

export class QuantumEarth extends Earth {
  protected override getAtmosphereColor(): number {
    throw new Error('Method not implemented.');
  }
  protected override getEnergyColor(): number {
    throw new Error('Method not implemented.');
  }
  protected override getParticleColor(): number {
    throw new Error('Method not implemented.');
  }
  protected override getShieldColor(): number {
    throw new Error('Method not implemented.');
  }
  protected override getCoreColor(): number {
    throw new Error('Method not implemented.');
  }
  constructor(scene: Phaser.Scene, x: number, y: number) {
    // Call parent constructor with proper parameters
    super(scene, x, y, 900, 0.08, 7, 18000, 0);
    
    // Set specific properties
    this.damageResistance = 0.08;
    this.specialAbility = 'Teleport';
    this.abilityCooldown = 18000;
  }

  override useSpecialAbility(): void {
    this.teleportTower();
  }

  override activateAbility(): void {
    this.playAbilityEffect();
    this.teleportTower();
  }

  private teleportTower(): void {
    // Teleport 1 tower (giả lập: chọn tower gần Earth nhất và di chuyển ra xa 120px)
    const towers = this.scene.children.list.filter(child =>
      child instanceof GameObject &&
      child.constructor && child.constructor.name.endsWith('Tower') &&
      child.x !== undefined && child.y !== undefined
    ) as GameObject[];
    if (towers.length === 0) return;
    
    // Tìm tower gần Earth nhất
    let nearest = towers[0] as GameObject;
    let minDist = Phaser.Math.Distance.Between(this.x, this.y, nearest.x, nearest.y);
    for (const t of towers) {
      const d = Phaser.Math.Distance.Between(this.x, this.y, t.x, t.y);
      if (d < minDist) {
        nearest = t;
        minDist = d;
      }
    }
    
    // Dịch chuyển tower ra xa Earth 120px theo hướng ngẫu nhiên
    const angle = Math.random() * Math.PI * 2;
    nearest.x = this.x + Math.cos(angle) * 120;
    nearest.y = this.y + Math.sin(angle) * 120;
  }

  override upgrade(): void {
    this.level++;
    this.baseMaxHealth += 180;
    this.baseDefense += 0.015;
    this.damageResistance += 0.015;
    this.recalculateStats();
    this.health = this.effectiveMaxHealth;
  }
} 